import { Network } from '@capacitor/network';
import { dbService } from './database';

class SyncService {
  private syncInProgress = false;
  private apiBaseUrl = 'https://safaricom.loholearning.co.ke/api'; // Update with your Laravel API endpoint

  async initialize(): Promise<void> {
    // Listen for network status changes
    Network.addListener('networkStatusChange', async (status) => {
      console.log('🌐 Network status changed:', status.connected);
      
      if (status.connected && !this.syncInProgress) {
        console.log('✅ Internet connected - starting sync...');
        await this.syncData();
      }
    });

    // Check current network status
    const status = await Network.getStatus();
    console.log('🌐 Current network status:', status.connected);
    
    if (status.connected) {
      await this.syncData();
    }
  }

  private async syncData(): Promise<void> {
    if (this.syncInProgress) {
      console.log('⏳ Sync already in progress...');
      return;
    }

    this.syncInProgress = true;
    console.log('🔄 Starting data sync...');

    try {
      await this.syncQuizResults();
      await this.syncProgress();
      console.log('✅ Sync completed successfully');
    } catch (error) {
      console.error('❌ Sync error:', error);
    } finally {
      this.syncInProgress = false;
    }
  }

  private async syncQuizResults(): Promise<void> {
    const unsyncedResults = await dbService.getUnsyncedQuizResults();
    
    console.log(`📤 Syncing ${unsyncedResults.length} quiz results...`);

    for (const result of unsyncedResults) {
      try {
        const response = await fetch(`${this.apiBaseUrl}/quiz-results`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.getAuthToken()}`
          },
          body: JSON.stringify({
            quiz_id: result.quiz_id,
            student_id: result.student_id,
            answers: JSON.parse(result.answers),
            score: result.score,
            submitted_at: result.submitted_at
          })
        });

        if (response.ok) {
          await dbService.markQuizResultSynced(result.id);
          console.log(`✅ Quiz result ${result.id} synced`);
        } else {
          console.error(`❌ Failed to sync quiz result ${result.id}`);
        }
      } catch (error) {
        console.error(`❌ Error syncing quiz result ${result.id}:`, error);
      }
    }
  }

  private async syncProgress(): Promise<void> {
    // Similar logic for syncing progress data
    console.log('🔄 Syncing progress data...');
    // Implementation depends on your API structure
  }

  private getAuthToken(): string {
    // Get auth token from localStorage or session
    return localStorage.getItem('auth_token') || '';
  }

  async checkConnection(): Promise<boolean> {
    const status = await Network.getStatus();
    return status.connected;
  }

  async manualSync(): Promise<void> {
    console.log('🔄 Manual sync triggered...');
    await this.syncData();
  }
}

export const syncService = new SyncService();
